import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmagazineService, EmagIssue } from './emagazine.service';

@Component({
  selector: 'app-emagazine-reader',
  templateUrl: './emagazine-reader.component.html',
  styleUrls: ['./emagazine-reader.component.scss']
})
export class EmagazineReaderComponent implements OnInit {
  loading = true;
  loadError = false;
  issue: EmagIssue | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: EmagazineService
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!id) { this.loadError = true; this.loading = false; return; }

    this.api.getById(id).subscribe({
      next: data => { this.issue = data; this.loading = false; },
      error: () => { this.loadError = true; this.loading = false; }
    });
  }

  back(): void {
    if (history.length > 1) history.back();
    else this.router.navigate(['/emagazine']);
  }

  home(): void { this.router.navigate(['/']); }

  openPdf(): void {
    const url = this.issue?.pdf_path;
    if (url) window.open(url, '_blank', 'noopener');
  }

  formatDate(input?: string | Date | null): string {
    if (!input) return '';
    const d = new Date(input);
    if (isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(d);
  }
}
